import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'addPunctuation' })
export class AddPunctuationPipe implements PipeTransform {
  transform(text: string): string {
    if (!text) {
      return '';
    }

    text = text.trim();

    return /\W$/.test(text) ? text : `${text}.`;
  }
}
